<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%">
        <a-button type="primary" @click="goToAddNewStockTransfer">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('form.NewStockTransfer') }}
        </a-button>
      </section>

      <a-row :gutter="24">
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.transferOrderSn"
            :placeholder="$t(`form.StockTransferNo`)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.outboundOrderSn"
            :placeholder="$t(`form.DeliveryOrderNo`)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.inboundOrderSn"
            :placeholder="$t(`form.ReceiptNo`)"
          />
        </a-col>
        <a-col :span="6">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseOrderStart"
            :placeholder="$t(`form.OrderTime`)"
            :start-time="formData.startTime"
            :end-time="formData.endTime"
          ></date-range-picker>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="6">
          <SelectWarehouseNew
            :placeholder="$t(`form.ShippingWarehouse`)"
            style="width: 100%"
            :code.sync="formData.outboundWarehouseCode"
            @change="chooseShippingWarehouse"
          />
        </a-col>
        <a-col :span="6">
          <SelectWarehouseNew
            :placeholder="$t(`form.ReceivingWarehouse`)"
            style="width: 100%"
            :code.sync="formData.inboundWarehouseCode"
            @change="chooseReceivingWarehouse"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="queryOrderList(1)" class="btnBgc">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`form.Search`) }}
          </a-button>
        </a-col>
      </a-row>
      <div class="table-content">
        <div class="table-header">
          <div class="row status-list-wrap">
            <input type="hidden" v-model="formData.status" />
            <a-tabs default-active-key="" @change="setSearchStatus">
              <a-tab-pane key="">
                <template slot="tab">
                  <span>{{ $t('form.All') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="item" v-for="item in transferStatusList">
                <template slot="tab">
                  <span>{{ $t(`form.${item}`) }}</span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <ul class="action-list" v-show="tableData.length">
            <li>
              <!-- 批量推送 -->
              <a-button class="btnBgc" @click="batchPush" :loading="pushLoading">
                {{ $t(`form.Push`) }}
              </a-button>
            </li>
          </ul>
        </div>
        <div class="table-body">
          <a-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :scroll="{ x: 1500 }"
            :columns="tableColumns"
            :data-source="tableData"
            rowKey="transferOrderId"
            :pagination="false"
            :loading="tableLoading"
            bordered
          >
            <template slot="transferOrderSn" slot-scope="text, record">
              <a @click="onCliCkDetail(record.transferOrderId)">{{ record.transferOrderSn }}</a>
            </template>
            <template slot="time" slot-scope="text, record">
              <div>
                <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.createdAt }}</div>
                <div class="time-item" v-if="record.outboundTime">
                  {{ $t('form.DeliveryCompletionTime') }}：{{ record.outboundTime }}
                </div>
                <div class="time-item" v-if="record.inboundTime">
                  {{ $t('form.WarehousingCompletionTime') }}：{{ record.inboundTime }}
                </div>
              </div>
            </template>
            <!-- 调拨数量 -->
            <template slot="TransferredQuantity" slot-scope="text, record">
              {{ record.quantitySum | toThousands }}
            </template>
            <!-- 已出库数 -->
            <template slot="IssuedQuantity" slot-scope="text, record">
              {{ record.outboundQuantitySum | toThousands }}
            </template>
            <!-- 已入库数 -->
            <template slot="ReceivedQuantity" slot-scope="text, record">
              {{ record.inboundQuantitySum | toThousands }}
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapState, mapMutations } from 'vuex'
import pagination from '@component/pagination'
import dateRangePicker from '@component/dateRangePicker'
import { getCookie } from '@/common/cookie'
import { Modal } from 'ant-design-vue'
import debounce from '@/common/debounce'
import SelectWarehouseNew from '@component/selectWarehouseNew'
export default {
  name: 'searchTransfer',
  mounted() {
    this.queryOrderList()
    this.sessionId = getCookie('d_session_id')
  },
  activated() {
    this.queryOrderList()
  },
  components: {
    pagination,
    dateRangePicker,
    SelectWarehouseNew,
  },
  data() {
    return {
      sessionId: '',
      status: '',
      formData: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      selectedRowKeys: [],
      tableLoading: false,
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: '',
        xlsRequestUrl: '',
        xlsDownloadUrl:
          'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx', //模板下载链接
      },
      visible: false,
      pushLoading: false,
    }
  },
  computed: {
    ...mapState(['transferStatusList']),
    tableColumns() {
      return [
        {
          dataIndex: 'transferOrderSn',
          title: this.$t('form.StockTransferNo'),
          key: 'transferOrderSn',
          scopedSlots: { customRender: 'transferOrderSn' },
          width: 200,
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 260,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: this.$t('form.BatchNo'),
          dataIndex: 'batchNo',
          key: 'batchNo',
          width: 200,
        },
        {
          title: this.$t('form.OrderStatus'),
          key: 'statusContent',
          dataIndex: 'status',
          customRender: (text) => this.getStatus(text),
          width: 150,
        },
        {
          title: this.$t('form.ShippingWarehouse'),
          key: 'outboundWarehouseName',
          dataIndex: 'outboundWarehouseName',
          width: 150,
        },
        {
          title: this.$t('form.ReceivingWarehouse'),
          key: 'inboundWarehouseName',
          dataIndex: 'inboundWarehouseName',
          width: 150,
        },
        {
          title: this.$t('form.TransferredQuantity'),
          key: 'quantitySum',
          dataIndex: 'quantitySum',
          width: 150,
          scopedSlots: { customRender: 'TransferredQuantity' },
        },
        {
          title: this.$t('form.IssuedQuantity'),
          key: 'outboundQuantitySum',
          dataIndex: 'outboundQuantitySum',
          width: 150,
          scopedSlots: { customRender: 'IssuedQuantity' },
        },
        {
          title: this.$t('form.ReceivedQuantity'),
          key: 'inboundQuantitySum',
          dataIndex: 'inboundQuantitySum',
          width: 150,
          scopedSlots: { customRender: 'ReceivedQuantity' },
        },
        {
          title: this.$t('form.WarehouseDeliveryOrderNo'),
          key: 'outboundOrderSn',
          dataIndex: 'outboundOrderSn',
          width: 200,
        },
        {
          title: this.$t('form.WarehouseReceiptNo'),
          key: 'inboundOrderSn',
          dataIndex: 'inboundOrderSn',
          width: 200,
        },
        {
          title: this.$t('创建人'),
          key: 'createdUser',
          dataIndex: 'createdUser',
          width: 120,
          customRender: (text) => decodeURIComponent(text),
        },
      ]
    },
    statusListTop() {
      return [
        {
          statusName: this.$t(`form.All`), //全部
          status: '',
        },
        {
          statusName: this.$t(`form.Enabled`), //"已启用",
          status: 'open',
        },
        {
          statusName: this.$t(`form.NotActive`), //"未激活",
          status: 'close',
        },
        {
          statusName: this.$t(`form.Deleted`), //已删除,
          status: 'delete',
        },
      ]
    },
    shopCode() {
      return this.$store.state.shopCode
    },
    buId() {
      return this.$store.getters.partyId
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    getStatus(text) {
      return this.$t(`form.${text}`)
    },
    //选择出货仓
    chooseShippingWarehouse(value) {
      if (value) {
        this.formData.outboundWarehouseCode = value
      } else {
        this.formData.outboundWarehouseCode = ''
      }
    },
    //选择收货仓
    chooseReceivingWarehouse(value) {
      if (value) {
        this.formData.inboundWarehouseCode = value
      } else {
        this.formData.inboundWarehouseCode = ''
      }
    },
    onCliCkDetail(id) {
      this.$router.push({
        name: 'transferDetail',
        query: { id },
      })
    },
    chooseOrderStart(date) {
      this.formData.startTime = date.start_time
      this.formData.endTime = date.end_time
    },
    goToAddNewStockTransfer() {
      this.$router.push('addTransfer')
    },
    queryOrderList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.$nextTick(async () => {
        let data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          transferOrderSn: this.formData.transferOrderSn,
          orderTimeStart: this.formData.startTime,
          orderTimeEnd: this.formData.endTime,
          outboundOrderSn: this.formData.outboundOrderSn,
          inboundOrderSn: this.formData.inboundOrderSn,
          outboundWarehouseCode: this.formData.outboundWarehouseCode,
          inboundWarehouseCode: this.formData.inboundWarehouseCode,
          status: this.formData.status,
        }

        this.tableLoading = true
        let res = await http({
          instance: this,
          type: 'post',
          url: api.transferOrderList,
          hasLoading: true,
          data,
        })
        let transferOrderList = [...(res.result.transferOrderList || '')]
        this.tableData = transferOrderList
        this.total = res.result.total
        this.tableLoading = false
      })
    },
    setSearchStatus(status) {
      this.$set(this.formData, 'status', status)
      this.queryOrderList()
      this.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    batchPush: debounce(async function () {
      await this.batchHandle({
        btn: 'pushLoading',
        modalAction: this.$t('form.Push'),
        url: api.batchTransferOrderPush,
      })
    }),
    confirmSelect() {
      let is_empty = false
      if (this.selectedRowKeys.length === 0) {
        is_empty = true
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
      }
      return is_empty
    },
    batchHandle({ modalAction, btn, url }) {
      if (this.confirmSelect()) return
      Modal.confirm({
        title: this.$t('form.Tips'),
        content: `${this.$t('form.Whether')} ${modalAction} ${this.$t('form.SelectOrder')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          this[btn] = true
          let transferOrderIds = [...this.selectedRowKeys]
          this.commonHttp({
            url,
            modalAction,
            data: { transferOrderIds },
          }).then(() => {
            this[btn] = false
            this.queryOrderList()
          })
        },
      })
    },
    async commonHttp({ url, modalAction, data }) {
      await http({
        instance: this,
        type: 'post',
        hasLoading: true,
        url,
        data,
      })
      this.$success({
        title: this.$t(`layer.Success`),
        content: `${modalAction}${this.$t('form.FINISH')}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.time-item {
  font-size: 13px;
}
.tab {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.65);
  height: 80px;
  width: 700px;
  margin-left: 200px;
  .tit {
    height: 80x;
    width: 100px;
    border-right: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item {
    display: flex;
    dl {
      width: 200px;
      text-align: center;
      dd {
        height: 40px;
        line-height: 40px;
      }
      dt {
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
</style>
